/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyNavInvestment } from './DailyNavInvestment';
import type { DailyNavPreviousValuation } from './DailyNavPreviousValuation';
import type { DailyNavRecordBreakdown } from './DailyNavRecordBreakdown';
import type { DailyNavRecordConfig } from './DailyNavRecordConfig';
import type { DailyNavRecordSecondaryBreakdown } from './DailyNavRecordSecondaryBreakdown';
import type { DailyNavReviewActionLog } from './DailyNavReviewActionLog';
import type { DailyNavReviewNote } from './DailyNavReviewNote';
import type { FirmDailyNav } from './FirmDailyNav';
export type DailyNavRecord = {
  readonly id?: number;
  firm: number;
  company: number;
  date: string;
  readonly status?: DailyNavRecord.status;
  reviewed_by_scalar?: boolean;
  discussed_with_fund?: boolean;
  price_adjusted?: boolean | null;
  price_adjustment_timing?: DailyNavRecord.price_adjustment_timing | null;
  pending_price_adjustment?: boolean;
  reviewed_by_scalar_at?: string | null;
  discussed_with_fund_at?: string | null;
  price_adjusted_at?: string | null;
  readonly review_notes?: string | null;
  readonly notes?: Array<DailyNavReviewNote>;
  /**
   * The latest review action per field (reviewed_by_scalar, discussed_with_fund, price_adjusted): who last changed it and when. At most one entry per field; absent fields have no recorded change.
   */
  readonly review_action_logs?: Array<DailyNavReviewActionLog>;
  /**
   * The FINAL allocation this NAV day opened against, carried from the previous NAV day's closed_allocation. Written at generation. Null on days generated before this was tracked, and on a company with no prior FINAL allocation.
   */
  previous_allocation?: number | null;
  /**
   * The FINAL allocation this NAV day's price came from. Written at finalize. Null on a day that was never finalized, and on rows migrated from the old measurement-date link whose allocation could not be resolved unambiguously.
   */
  closed_allocation?: number | null;
  previous_valuation?: DailyNavPreviousValuation;
  /**
   * Fund-security holdings at previous_allocation's measurement date. Empty when the day has no pin, or the company had no fund position then.
   */
  readonly investments?: Array<DailyNavInvestment>;
  readonly cap_iq_delta_exceeded?: boolean;
  breakdown?: DailyNavRecordBreakdown;
  readonly secondary_delta_exceeded?: boolean;
  secondary_breakdown?: DailyNavRecordSecondaryBreakdown;
  config?: DailyNavRecordConfig;
  day?: FirmDailyNav;
  readonly finalized_at?: string | null;
  readonly finalized_by_name?: string | null;
  readonly staff_finalize_confirmation?: string | null;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace DailyNavRecord {
  export enum status {
    REVIEWED = 'reviewed',
    IN_PROGRESS = 'in_progress',
    REVIEW_PRICE = 'review_price',
    REVIEW_STATUS = 'review_status',
    NEEDS_NEW_PRICE = 'needs_new_price',
  }
  export enum price_adjustment_timing {
    TODAY = 'today',
    NEXT_DAY = 'next_day',
  }
}

